module.exports = __webpack_public_path__ + "img/Piazza_del_Duomo.8d2d20e0.jpg";